<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''"> 
            <i id="backArrow" @click="openSubcat" class="fas fa-chevron-circle-left"></i>{{title}}{{subName}}
          </h3>
        </div>
        <div class="col text-right">
          <button @click="newB()" type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#exampleModal">Add new</button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <vue-good-table
          :line-numbers="true"
          :columns="columns"
          :rows="rows"
          :pagination-options="{
              enabled: true,
              mode: 'pages',
              perPage: 10
              }"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
            }"
          >
              <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <button class="btn btn-success btn-sm" @click="openproducts(props.row.id,props.row.name,props.row.product)" >products</button>
          <button @click="editBrand(props.row)" type="button" class="btn btn-sm btn-primary btn-circle">
              <i class="fas fa-edit"></i>
          </button>  
          <button @click="deleteBrand(props.row.id)" type="button" class="btn btn-danger btn-sm btn-circle">
              <i  class="fas fa-trash"></i>
          </button>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
      
      </vue-good-table>
    </div>

    <newbrand @reload="getbrands" :form='form' :subName="subName" :Cid="Cid"></newbrand>
     <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
  </div>
  </div>
</template>
<script>
import newbrand from '../modals/NewBrand'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: 'BrandsTable',
    components:{
      Loading,
      newbrand
    },
    props: {
      type: String,
      title: String,
      Sid:Number,
      Cid:Number,
      subName:String
    },
    data() {
      return {
        form:{
              id: 0,
              name: '',
              description:'',
              subId: this.Sid,
          },
        fullPage:true,
        isLoading:false,
       columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Actions',
          field: 'action',
          
        },
        ],
        rows: [],
        brand:{
          id: 0,
          name: '',
          products:[]
        }
      }
    },
     created(){
      this.getbrands();
    },
    methods:{
       newB(){
        this.form.id = 0;
        this.form.name = ''
        this.form.description = '';
        this.form.subId = Sid;
      },
      openproducts(id, name,products){
        this.brand.id = id;
        this.brand.name = name;
        this.brand.products = products
        this.$emit("openProducts", this.brand);
      },
      getbrands(){
        let path = 'admin/shopLocal/my-brands/' + this.Sid;
        this.axios.get(path)
        .then((response)=>{
          this.rows = response.data
        })
      },
       openSubcat(){
        this.$emit("openSubcat");
      },
      deleteBrand(id) {
                this.$swal({ 
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                      this.isLoading = true;
                        this.axios.delete('/admin/shopLocal/brands/' + id).then(() => {
                            this.isLoading = false;
                            this.$swal(
                                'Deleted!',
                                'Category has been deleted.',
                                'success'
                            )
                            this.getbrands();
                        })
                        .catch(() => {
                            this.isLoading = false;
                            this.$swal("Failed!", "There was something wrong.", "warning");
                })
                    }
                })
            },
            editBrand(row){
              this.form.id = row.id
              this.form.name = row.name
              this.form.description = row.description
              $('#exampleModal').modal('show');
          }
    }
  }
</script>
<style>
</style>
<style>
  #backArrow{
    font-size: 30px;
    color: green;
    margin-right: 20px;
  }
  #backArrow:hover{
    cursor: pointer;
    color: greenyellow;
    transition-duration: 1s;
  }
</style>
